import { Api as ChangiRecommends } from '@/http/ChangiRecommendsApi';
import { Api as Phoenix } from '@/http/PhoenixApi';
import { Api as ProductEditor } from '@/http/ProductEditorApi';
import securityWorker from '@/auth/SecurityWorker';
import { ENV } from '@/env';
const errorInterceptor = (error) => {
    const { data, ...other } = error.response;
    const result = { data, responseDetails: other };
    return Promise.reject(result);
};
const responseInterceptor = (res) => res;
export const apiFactory = () => {
    const ChangiRecommendsApi = new ChangiRecommends({
        securityWorker,
        baseURL: ENV.API_BASE_URL,
    });
    ChangiRecommendsApi.instance.interceptors.response.use(responseInterceptor, errorInterceptor);
    const phoenixApi = new Phoenix({
        securityWorker,
        baseURL: ENV.COREAPI_DOMAIN,
    });
    const productEditorApi = new ProductEditor({
        securityWorker,
        url: '',
    });
    const apis = { ChangiRecommendsApi, phoenixApi, productEditorApi };
    return apis;
};
export const vueInstanceApiFactory = () => {
    const ChangiRecommendsApi = new ChangiRecommends({
        securityWorker,
        baseURL: ENV.API_BASE_URL,
    });
    const phoenixApi = new Phoenix({
        securityWorker,
        baseURL: ENV.COREAPI_DOMAIN,
    });
    const productEditorApi = new ProductEditor({
        securityWorker,
        baseURL: ENV.API_BASE_URL,
    });
    const apis = { ChangiRecommendsApi, phoenixApi, productEditorApi };
    return apis;
};
